module.exports = __webpack_public_path__ + "media/images/countryrect/kn-3539b6894a66e9f19cede6110bfda573.svg";